import store from '../../store'
import { GraphqQlApi as api } from '@/api/api.js'

export default {
  saveAppVersion: function (version) {
    store.commit('SET_APP_VERSION', { version })
  },

  subscribeToVerifyVersion: async function (appName) {
    try {
      const response = await api.getApplicationVersionAsync(appName)
      if (!response) {
        // if request is faild, try again in 5 minutes
        await new Promise(resolve => setTimeout(resolve, 300000))
        await this.subscribeToVerifyVersion(appName)
      }

      if (response.errors) {
        // if gq request has errors, try again in 5 minutes
        await new Promise(resolve => setTimeout(resolve, 300000))
        await this.subscribeToVerifyVersion(appName)
      } else {
        const appVersion = response.data.webAppModelerQuery.appVersion
        if (appVersion !== store.state.general.appVersion) {
          store.commit('SET_NEED_REFRESH_APP', { needRefreshApp: true })
          return
        }

        // pooling (send request every 10 minutes)
        await new Promise(resolve => setTimeout(resolve, 600000))
        await this.subscribeToVerifyVersion(appName)
      }
    } catch (err) {
      console.error('Something wrong during long pooling in sbuscribeToVerifyVersion', err)
    }
  },

  getAndSetAppVersion: async function (appName) {
    try {
      const response = await api.getApplicationVersionAsync(appName)
      if (!response) {
        return
      }

      const appVersion = response.data.webAppModelerQuery.appVersion
      this.saveAppVersion(appVersion)
    } catch (err) {
      console.error('Something wrong during requests to api', err)
    }
  }
}